import {TabDefinition} from '@/tabs/TabDefinition.type'
import GenericSettings from '@/org-settings/GenericSettings.vue'
import EhfSettings from '@/org-settings/EhfSettings.vue'
import PatronSettings from '@/org-settings/PatronSettings.vue'
import BankSettings from '@/org-settings/BankSettings.vue'
import ApprovalSettings from '@/org-settings/ApprovalSettings.vue'
import DebtCollectionSettings from '@/org-settings/DebtCollectionSettings.vue'
import {ShowDebtCollection} from '@/tenants/org.features'

export const orgSettingTabs: TabDefinition[] = [
    {
        title: 'Generelt',
        key: 'general',
        component: GenericSettings,
        enabled: true
    },
    {
        title: 'EHF',
        key: 'ehf',
        component: EhfSettings,
        enabled: true
    },
    {
        title: 'Bilagsmottak',
        key: 'patron',
        component: PatronSettings,
        enabled: true
    },
    {
        title: 'Bank',
        key: 'bank',
        component: BankSettings,
        enabled: true,
        ['data-cy']: 'settings-tab-bank'
    },
    {
        title: 'Godkjenningsflyt',
        key: 'approvalflow',
        component: ApprovalSettings,
        enabled: true
    },
    {
        title: 'Purring og inkasso',
        key: 'debtCollection',
        component: DebtCollectionSettings,
        enabled: ShowDebtCollection.isEnabled()
    }
]

export const findTab = (tabKey: string) => {
    return orgSettingTabs.find(tab => tab.key === tabKey) || orgSettingTabs[0]
}